export const createFood = `
  mutation CreateFood($foodInput:FoodInput!){
      createFood(
          foodInput:$foodInput
      ){
        _id
      categories{
        _id
        title
        foods{
          _id
          title
          description
          variations{
            _id
            title
            price
            discounted
            addons
          }
          image
          isActive
        }
        createdAt
        updatedAt
      }
      }
    }`

export const editFood = `
    mutation EditFood($foodInput:FoodInput!){
        editFood(
            foodInput:$foodInput
        ){
            _id
            categories{
              _id
              title
              foods{
                _id
                title
                description
                variations{
                  _id
                  title
                  price
                  discounted
                  addons
                }
                image
                isActive
              }
              createdAt
              updatedAt
            }
        }
      }`

export const deleteFood = `
      mutation DeleteFood($id:String!,$restaurant:String!,$categoryId:String!){
        deleteFood(id:$id,restaurant:$restaurant,categoryId:$categoryId){
          _id
          categories{
            _id
            title
            foods{
              _id
              title
              description
              variations{
                _id
                title
                price
                discounted
                addons
              }
              image
              isActive
            }
            createdAt
            updatedAt
          }
        }
      }`

export const createCategory = `
mutation CreateCategory($category:CategoryInput!){
  createCategory(category:$category){
    _id
    categories{
      _id
      title
      foods{
        _id
        title
        description
        variations{
          _id
          title
          price
          discounted
          addons
        }
        image
        isActive
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}`

export const editCategory = `
      mutation EditCategory($category:CategoryInput!){
        editCategory(category:$category){
          _id
          categories{
            _id
            title
            foods{
              _id
              title
              description
              variations{
                _id
                title
                price
                discounted
                addons
              }
              image
              isActive
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
      }`

export const deleteCategory = `
      mutation DeleteCategory($id:String!,$restaurant:String!){
        deleteCategory(id:$id,restaurant:$restaurant){
                _id
                categories{
                  _id
                  title
                  foods{
                    _id
                    title
                    description
                    variations{
                      _id
                      title
                      price
                      discounted
                      addons
                    }
                    image
                    isActive
                    createdAt
                    updatedAt
                  }
                  createdAt
                  updatedAt
                }
        }
      }`

export const saveEmailConfiguration = `mutation SaveEmailConfiguration($configurationInput:EmailConfigurationInput!){
  saveEmailConfiguration(configurationInput:$configurationInput){
    _id
    email
    emailName
    password
    enableEmail
  }
}`
export const saveFormEmailConfiguration = `mutation  SaveFormEmailConfiguration($configurationInput:FormEmailConfigurationInput!){
  saveFormEmailConfiguration(configurationInput: $configurationInput) {
    _id
    formEmail

  }
}`
export const saveSendGridApiKey = `mutation SaveSendGridApiKey($configurationInput: SendGridConfigurationInput!) {
  saveSendGridConfiguration(configurationInput: $configurationInput) {
    _id
    sendGridApiKey
    sendGridEnabled
    sendGridEmail
    sendGridEmailName
    sendGridPassword 
  }
}`

export const saveFirebaseConfiguration = `
  mutation SaveFirebaseConfiguration(
    $configurationInput:FirebaseConfigurationInput!
  ) {
    saveFirebaseConfiguration(configurationInput: $configurationInput) {
      _id
      firebaseKey
      authDomain
      projectId
      storageBucket
      msgSenderId
      appId
      measurementId
      vapidKey
    }
  }
`

export const saveSentryConfiguration = `
  mutation SaveSentryConfiguration($configurationInput: SentryConfigurationInput!) {
    saveSentryConfiguration(configurationInput: $configurationInput) {
      _id
      dashboardSentryUrl
      webSentryUrl
      apiSentryUrl
      customerAppSentryUrl
      restaurantAppSentryUrl
      riderAppSentryUrl
    }
  }
`
export const saveRestaurantAppReleaseConfiguration = `
  mutation SaveRestaurantAppReleaseConfiguration($configurationInput: RestaurantAppReleaseConfigurationInput!) {
    saveRestaurantAppReleaseConfiguration(configurationInput: $configurationInput) {
      _id
      restaurantAppLatestVersion
      restaurantAppDownloadUrl
    }
  }
`
export const saveGoogleApiKeyConfiguration = `
  mutation SaveGoogleApiKeyConfiguration(
    $configurationInput: GoogleApiKeyConfigurationInput!
  ) {
    saveGoogleApiKeyConfiguration(configurationInput: $configurationInput) {
      _id
      googleApiKey
      mapboxToken
    }
  }
`
export const saveCloudinaryConfiguration = `mutation SaveCloudinaryConfiguration($configurationInput: CloudinaryConfigurationInput!) {
  saveCloudinaryConfiguration(configurationInput: $configurationInput) {
    _id
    cloudinaryUploadUrl
    cloudinaryApiKey
 
  }
}
`
export const saveAmplitudeApiKeyConfiguration = `
  mutation SaveAmplitudeApiKeyConfiguration(
    $configurationInput: AmplitudeApiKeyConfigurationInput!
  ) {
    saveAmplitudeApiKeyConfiguration(configurationInput: $configurationInput) {
      _id
      webAmplitudeApiKey
      appAmplitudeApiKey
    }
  }
`
export const saveGoogleClientIDConfiguration = `mutation SaveGoogleClientIDConfiguration($configurationInput: GoogleClientIDConfigurationInput!) {
  saveGoogleClientIDConfiguration(configurationInput: $configurationInput) {
    _id
    webClientID
    androidClientID
    iOSClientID
    expoClientID
  }
}
`
export const saveWebConfiguration = `
  mutation SaveWebConfiguration($configurationInput: WebConfigurationInput!) {
    saveWebConfiguration(configurationInput: $configurationInput) {
      _id
    
      googleMapLibraries
      googleColor
    }
  }
`

export const saveAppConfiguration = `
  mutation SaveAppConfiguration($configurationInput: AppConfigurationsInput!) {
    saveAppConfigurations(configurationInput: $configurationInput) {
      _id
    
      termsAndConditions
      privacyPolicy
      testOtp
    }
  }
`
export const saveDeliveryRateConfiguration = `mutation SaveDeliveryRateConfiguration($configurationInput: DeliveryRateConfigurationInput!) {
  saveDeliveryRateConfiguration(configurationInput: $configurationInput) {
    _id
    deliveryRate
    costType
    nearbyRadiusMiles
    pickupRadiusMiles
    serverTipShare
  }
}`;

export const savePaypalConfiguration = `mutation SavePaypalConfiguration($configurationInput:PaypalConfigurationInput!){
  savePaypalConfiguration(configurationInput:$configurationInput){
    _id
    clientId
    clientSecret
    sandbox
  }
}`

export const savePaymentGateways = `mutation SavePaymentGateways($qor:Boolean!,$stripe:Boolean!){
  savePaymentGateways(qor:$qor,stripe:$stripe){
    _id
    qorPaymentsEnabled
    stripePaymentsEnabled
  }
}`

export const saveStripeProcessingFee = `mutation SaveStripeProcessingFee($percent:Float!,$fixed:Float!){
  saveStripeProcessingFee(percent:$percent,fixed:$fixed){
    _id
    stripeProcessingFeePercent
    stripeProcessingFeeFixed
  }
}`

export const setStripeRestaurantProcessingFee = `mutation SetStripeRestaurantProcessingFee($restaurantId:ID!,$percent:Float,$fixed:Float){
  setStripeRestaurantProcessingFee(restaurantId:$restaurantId,percent:$percent,fixed:$fixed){
    restaurantId
    processingFeePercentOverride
    processingFeeFixedOverride
    processingFeePercent
    processingFeeFixed
  }
}`

export const saveStripeRestaurantDashboard = `mutation SaveStripeRestaurantDashboard($enabled:Boolean!){
  saveStripeRestaurantDashboard(enabled:$enabled){
    _id
    stripeRestaurantDashboard
  }
}`

export const setStripeRestaurantDashboard = `mutation SetStripeRestaurantDashboard($restaurantId:ID!,$enabled:Boolean!){
  setStripeRestaurantDashboard(restaurantId:$restaurantId,enabled:$enabled){
    restaurantId
    dashboardEnabled
  }
}`

export const createStripeAccountSession = `mutation CreateStripeAccountSession($restaurantId:ID!){
  createStripeAccountSession(restaurantId:$restaurantId){
    accountId
    clientSecret
    publishableKey
    expiresAt
  }
}`

export const removeStripeRestaurantAccount = `mutation RemoveStripeRestaurantAccount($restaurantId:ID!){
  removeStripeRestaurantAccount(restaurantId:$restaurantId){
    restaurantId
    accountId
    detailsSubmitted
    transfersActive
    payoutsEnabled
  }
}`

export const createStripeOwnerOnboardingLink = `mutation CreateStripeOwnerOnboardingLink($restaurantId:ID!){
  createStripeOwnerOnboardingLink(restaurantId:$restaurantId){
    accountId
    url
  }
}`

export const saveStripeConfiguration = `mutation SaveStripeConfiguration($configurationInput:StripeConfigurationInput!){
  saveStripeConfiguration(configurationInput:$configurationInput){
    _id
    publishableKey
    secretKey
  
  }
}`

export const saveNMIConfiguration = `mutation SaveNMIConfiguration($configurationInput:NMIConfigurationInput!){
  saveNMIConfiguration(configurationInput:$configurationInput){
    _id
    nmiSecurityKey
    nmiTokenizationKey
  }
}`

export const saveQorConfiguration = `mutation SaveQorConfiguration($configurationInput:QorConfigInput!){
  saveQorConfiguration(configurationInput:$configurationInput){
    _id
    enabled
    sandbox
    platformCommissionRate
    deliveryCommissionRate
    selfDeliveryCommissionRate
    pickupCommissionRate
    flatFee
    platformKeepsTax
  }
}`

export const boardRestaurantQor = `mutation BoardRestaurantQor($restaurantId:ID){
  boardRestaurantQor(restaurantId:$restaurantId){
    restaurantId
    qorMerchantId
    qorMid
    qorBoardingStatus
    qorBoardingStatusLabel
    qorKycStatus
    message
  }
}`

export const refreshQorBoardingStatus = `mutation RefreshQorBoardingStatus($restaurantId:ID!){
  refreshQorBoardingStatus(restaurantId:$restaurantId){
    restaurantId
    qorMid
    qorBoardingStatus
    qorBoardingStatusLabel
    qorKycStatus
    message
  }
}`

export const saveRestaurantKyc = `mutation SaveRestaurantKyc($restaurantId:ID!,$kyc:QorKycInput!){
  saveRestaurantKyc(restaurantId:$restaurantId,kyc:$kyc){
    restaurantId
    qorKycStatus
    qorMerchantId
    qorMid
    qorBoardingStatus
    qorBoardingStatusLabel
    message
  }
}`

export const createStripeRestaurantAccount = `mutation CreateStripeRestaurantAccount($restaurantId:ID!){
  createStripeRestaurantAccount(restaurantId:$restaurantId){
    restaurantId
    restaurantName
    accountId
    detailsSubmitted
    transfersActive
    payoutsEnabled
  }
}`

export const stripeRestaurantOnboardingLink = `mutation StripeRestaurantOnboardingLink($restaurantId:ID!){
  stripeRestaurantOnboardingLink(restaurantId:$restaurantId){
    accountId
    url
  }
}`

export const refreshStripeRestaurantAccount = `mutation RefreshStripeRestaurantAccount($restaurantId:ID!){
  refreshStripeRestaurantAccount(restaurantId:$restaurantId){
    restaurantId
    restaurantName
    accountId
    detailsSubmitted
    transfersActive
    payoutsEnabled
  }
}`

export const payOutPendingStripeTransfers = `mutation PayOutPendingStripeTransfers($restaurantId:ID){
  payOutPendingStripeTransfers(restaurantId:$restaurantId){
    considered
    transferred
    paid
  }
}`

export const refundStripeOrder = `mutation RefundStripeOrder($orderId:ID!,$amount:Float,$chargeTo:String,$note:String){
  refundStripeOrder(orderId:$orderId,amount:$amount,chargeTo:$chargeTo,note:$note){
    ok
    refunded
    reversed
    debt
    refundId
    fullyRefunded
    message
  }
}`

export const refundQorOrder = `mutation RefundQorOrder($orderId:ID!,$amount:Float){
  refundQorOrder(orderId:$orderId,amount:$amount){
    ok
    transactionId
    code
    message
  }
}`

export const voidQorOrder = `mutation VoidQorOrder($orderId:ID!){
  voidQorOrder(orderId:$orderId){
    ok
    transactionId
    code
    message
  }
}`

export const refreshQorSettlement = `mutation RefreshQorSettlement($orderId:ID!){
  refreshQorSettlement(orderId:$orderId){
    ok
    transactionId
    code
    message
  }
}`

export const saveTwilioConfiguration = `mutation saveTwilioConfiguration($configurationInput:TwilioConfigurationInput!){
  saveTwilioConfiguration(configurationInput:$configurationInput){
    _id
    twilioAccountSid
    twilioAuthToken
    twilioPhoneNumber
    twilioEnabled
  }
}`

export const saveVerificationToggles = `mutation SaveVerificationsToggle($configurationInput:VerificationConfigurationInput!){
  saveVerificationsToggle(configurationInput: $configurationInput) {
    skipEmailVerification
    skipMobileVerification
  }
}`

export const saveCurrencyConfiguration = `mutation SaveCurrencyConfiguration($configurationInput:CurrencyConfigurationInput!){
  saveCurrencyConfiguration(configurationInput:$configurationInput){
    _id
    currency
    currencySymbol
  }
}`

export const ownerLogin = `mutation ownerLogin($email:String!,$password:String!){
  ownerLogin(email:$email,password:$password){
    userId
    token
    email
    userType
    restaurants{
      _id
      orderId
      name
      image
      address
    }
  }
}`

export const createSection = `mutation CreateSection($section:SectionInput!){
  createSection(section:$section){
      _id
      name
      enabled
      restaurants{
        _id
        name
      }
    }
}`
export const editSection = `mutation editSection($section:SectionInput!){
  editSection(section:$section){
      _id
      name
      enabled
      restaurants{
        _id
        name
      }
    }
}`

export const deleteSection = `mutation DeleteSection($id:ID!){
  deleteSection(id:$id){
    _id
  }
}`

export const deleteVendor = `mutation DeleteVendor($id:ID!){
  deleteVendor(id:$id){
    _id
  }
}`

export const updateOrderStatus = `mutation UpdateOrderStatus($id:ID!,$status:String!,$reason:String,$reasonComments:String){
  updateOrderStatus(id:$id,status:$status,reason:$reason,reasonComments:$reasonComments){
    _id
    orderStatus
  }
}
`
export const updateStatus = `mutation UpdateStatus($id:ID!,$orderStatus:String!){
  updateStatus(id:$id,orderStatus:$orderStatus){
    _id
    orderStatus
  }
}
`

export const markOrderPrepared = `mutation MarkOrderPrepared($id:ID!){
  markOrderPrepared(_id:$id){
    _id
    orderStatus
    preparedAt
  }
}
`

export const uploadToken = `mutation UploadToken($id:String!,$pushToken:String!){
  uploadToken(id:$id,pushToken:$pushToken){
    _id
    pushToken
  }
}`

export const resetPassword = `mutation ResetPassword($password:String!,$token:String!){
  resetPassword(password:$password,token:$token){
    result
  }
}`

export const createRider = `
mutation CreateRider($riderInput:RiderInput!){
    createRider(
        riderInput:$riderInput
    ){
    _id
    name
    username
    password
    phone
    available
      zone{
        _id
      }
    }
  }`

export const editRider = `
    mutation EditRider($riderInput:RiderInput!){
        editRider(
          riderInput:$riderInput
        ){
          _id
          name
          username
          phone
          zone{
            _id
          }
        }
      }`
export const deleteRider = `
      mutation DeleteRider($id:String!){
        deleteRider(id:$id){
          _id
        }
      }`

export const toggleAvailablity = `
      mutation ToggleRider($id:String){
        toggleAvailablity(id:$id){
          _id
        }
}`

export const assignRider = ` mutation AssignRider($id:ID!,$riderId:ID!){
  assignRider(id:$id,riderId:$riderId){
    _id
    orderStatus
    rider{
      _id
      name
    }
  }
}`

export const dispatchOrderToFirstDelivery = `mutation DispatchOrderToFirstDelivery($id:ID!){
  dispatchOrderToFirstDelivery(id:$id){
    _id
    orderStatus
    firstDeliveryOrderId
    fdDriverName
    fdDriverPhone
    fdDriverTransport
    fdTrackerLink
  }
}`

// A self-delivery restaurant's board: hand an order to RushMyFood riders
// (then First Delivery) when its own drivers can't take it.
export const sendOrderToRushmyfoodDelivery = `mutation SendOrderToRushmyfoodDelivery($id:ID!){
  sendOrderToRushmyfoodDelivery(id:$id){
    _id
    orderStatus
    dispatchTier
    firstDeliveryOrderId
  }
}`

export const updatePaymentStatus = `mutation UpdatePaymentStatus($id:String!,$status:String!){
  updatePaymentStatus(id:$id,status:$status){
    _id
    paymentStatus
    paidAmount
  }
}
`

export const createOffer = `mutation CreateOffer($offer:OfferInput!){
  createOffer(offer:$offer){
      _id
      name
      tag
      restaurants{
        _id
        name
        address
      }
    }
}`

export const editOffer = `mutation EditOffer($offer:OfferInput!){
  editOffer(offer:$offer){
      _id
      name
      tag
      restaurants{
        _id
        name
        address
      }
    }
}`

export const deleteOffer = `mutation DeleteOffer($id:String!){
  deleteOffer(id:$id)
}`

export const createOptions = `mutation CreateOptions($optionInput:CreateOptionInput){
  createOptions(optionInput:$optionInput){
    _id
    options{
      _id
      title
      description
      price
    }
  }
}`

export const createAddons = `mutation CreateAddons($addonInput:AddonInput){
  createAddons(addonInput:$addonInput){
      _id
      addons{
        _id
        options
        title
        description
        quantityMinimum
        quantityMaximum
      }
      
    }
}`
export const editAddon = `mutation editAddon($addonInput:editAddonInput){
  editAddon(addonInput:$addonInput){
      _id
      addons{
        _id
        options
        title
        description
        quantityMinimum
        quantityMaximum
      }
  }
}`

export const deleteAddon = `
      mutation DeleteAddon($id:String!,$restaurant:String!){
        deleteAddon(id:$id,restaurant:$restaurant){
          _id
          addons{
            _id
            options
            title
            description
            quantityMinimum
            quantityMaximum
          }
        }
      }`

export const deleteOption = `
      mutation DeleteOption($id:String!,$restaurant:String!){
        deleteOption(id:$id,restaurant:$restaurant){
          _id
          options{
            _id
            title
            description
            price
          }
        }
      }`
export const editOption = `mutation editOption($optionInput:editOptionInput){
  editOption(optionInput:$optionInput){
          _id
          options{
            _id
            title
            description
            price
          }
        }
      }`

export const createCoupon = `mutation CreateCoupon($couponInput:CouponInput!){
  createCoupon(couponInput:$couponInput){
    _id
    title
    discount
    enabled
  }
}`
export const editCoupon = `mutation editCoupon($couponInput:CouponInput!){
  editCoupon(couponInput:$couponInput){
        _id
        title
        discount
        enabled
        }
      }`
export const deleteCoupon = `mutation DeleteCoupon($id:ID!){
        deleteCoupon(id:$id){
          _id
          title
        }
      }`

export const createCuisine = `mutation CreateCuisine($cuisineInput:CuisineInput!){
        createCuisine(cuisineInput:$cuisineInput){
          _id
          name
          description
          image
        shopType
        }
      }`
export const editCuisine = `mutation editCuisine($cuisineInput:CuisineInput!){
        editCuisine(cuisineInput:$cuisineInput){
          _id
          name
          description
          image
      shopType
              }
            }`
export const deleteCuisine = `mutation DeleteCuisine($id:ID!){
              deleteCuisine(id:$id){
                _id
                name
              }
            }`

export const createBanner = `mutation CreateBanner($bannerInput:BannerInput!){
  createBanner(bannerInput:$bannerInput){
    _id
    title
    description
    action
    file
    screen
    parameters
  }
}`

export const editBanner = `mutation editBanner($bannerInput:BannerInput!){
  editBanner(bannerInput:$bannerInput){
    _id
    title
    description
    action
    file
    screen
    parameters
  }
}`

export const deleteBanner = `mutation DeleteBanner($id:String!){
  deleteBanner(id:$id)
}`

export const createTipping = `mutation CreateTipping($tippingInput:TippingInput!){
        createTipping(tippingInput:$tippingInput){
          _id
          tipVariations
          enabled
        }
      }`

export const editTipping = `mutation editTipping($tippingInput:TippingInput!){
  editTipping(tippingInput:$tippingInput){
            _id
            tipVariations
            enabled
              }
            }`

export const createTaxation = `mutation CreateTaxation($taxationInput:TaxationInput!){
    createTaxation(taxationInput:$taxationInput){
          _id
        taxationCharges
        enabled
        }
      }`

export const editTaxation = `mutation editTaxation($taxationInput:TaxationInput!){
    editTaxation(taxationInput:$taxationInput){
            _id
            taxationCharges
            enabled
              }
            }`

export const createVendor = `mutation CreateVendor($vendorInput:VendorInput!){
    createVendor(vendorInput:$vendorInput){
      _id
      name
      email
      userType
    }
}`

export const editVendor = `mutation EditVendor($vendorInput:VendorInput!){
  editVendor(vendorInput:$vendorInput){
    _id
    name
    phone
    email
    userType
    isActive
  }
}`

export const editRestaurant = `mutation EditRestaurant($restaurantInput:RestaurantInput!){
    editRestaurant(restaurantInput:$restaurantInput){
      _id
      orderId
      orderPrefix
      name
      image
      logo
      slug
      address
      username
      password
      phone
      location{coordinates}
      isAvailable
      minimumOrder
      tax
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      shopType
      firstDeliveryMerchantId
      isMobile
      timezone
      mobileDeliveryEnabled
      mobileDeliveryRadiusMiles
    }
}`

export const setRestaurantFdMerchantId = `mutation SetRestaurantFdMerchantId($restaurantId:ID!,$firstDeliveryMerchantId:String){
  setRestaurantFdMerchantId(restaurantId:$restaurantId,firstDeliveryMerchantId:$firstDeliveryMerchantId){
    _id
    firstDeliveryMerchantId
  }
}`

export const createZone = `mutation CreateZone($zone:ZoneInput!){
  createZone(zone:$zone){
    _id
    title
    description
    location{coordinates}
    isActive
  }
}`

export const editZone = `mutation EditZone($zone:ZoneInput!){
  editZone(zone:$zone){
    _id
    title
    description
    location{coordinates}
    isActive
  }
}`

export const deleteZone = `mutation DeleteZone($id:String!){
  deleteZone(id:$id){
    _id
    title
    description
    location{coordinates}
    isActive
  }
}`

export const vendorResetPassword = `mutation VendorResetPassword($oldPassword: String!, $newPassword: String!){
    vendorResetPassword(oldPassword: $oldPassword, newPassword: $newPassword){
      _id
      email
      token
    }
}`

export const deleteRestaurant = `mutation DeleteRestaurant($id:ID!){
  deleteRestaurant(id:$id){
    _id
    isActive
  }
}`

export const updateTimings = `mutation UpdateTimings($id:ID!,$openingTimes:[OpeningTimeInput]){
  updateTimings(id:$id,
    openingTimes:$openingTimes){
    _id
    openingTimes{
      day
      times{
        startTime
        endTime
      }
    }
  }
}`

export const sendNotificationUser = `mutation SendNotificationUser($notificationTitle:String!, $notificationBody: String!){
  sendNotificationUser(notificationTitle:$notificationTitle,notificationBody:$notificationBody)
}
`
export const updateCommission = `mutation UpdateCommission($id:ID!,$deliveryCommissionRate:Float,$selfDeliveryCommissionRate:Float,$pickupCommissionRate:Float,$platformKeepsTax:Boolean,$serviceFee:Float,$thirdPartyPercent:Float){
  updateCommission(id:$id,deliveryCommissionRate:$deliveryCommissionRate,selfDeliveryCommissionRate:$selfDeliveryCommissionRate,pickupCommissionRate:$pickupCommissionRate,platformKeepsTax:$platformKeepsTax,serviceFee:$serviceFee,thirdPartyPercent:$thirdPartyPercent){
    _id
    commissionRate
    deliveryCommissionRate
    selfDeliveryCommissionRate
    pickupCommissionRate
    platformKeepsTax
    serviceFeeOverride
    thirdPartyPercent
  }
}`
export const createRestaurant = `mutation CreateRestaurant($restaurant:RestaurantInput!,$owner:ID!){
  createRestaurant(restaurant:$restaurant,owner:$owner){
    _id
    orderId
    orderPrefix
    name
    slug
    image
    logo
    address
    username
    password
    phone
    minimumOrder
    tax
    location{coordinates}
    shopType
    cuisines
    isMobile
  }
}`

export const updateDeliveryBoundsAndLocation = `mutation UPDATE_DELIVERY_BOUNDS_AND_LOCATION( $id: ID!
    $boundType: String!
    $bounds: [[[Float!]]]
    $circleBounds: CircleBoundsInput
    $location: CoordinatesInput!
    $address: String
    $postCode: String
    $city: String){

    result: updateDeliveryBoundsAndLocation(
      id: $id
      boundType: $boundType
      circleBounds: $circleBounds
      bounds: $bounds
      location: $location
      address: $address
      postCode: $postCode
      city: $city
    ) {
      success
      message
      data {
        _id
        deliveryBounds {
          coordinates
        }
        location {
          coordinates
        }
      }
  }
}`

export const updateBankAccount = `mutation UpdateBankAccount($bankAccountName:String!,$bankRoutingNumber:String!,$bankAccountNumber:String!){
  updateBankAccount(bankAccountName:$bankAccountName,bankRoutingNumber:$bankRoutingNumber,bankAccountNumber:$bankAccountNumber){
    bankAccountName
    bankAccountLast4
    hasBankAccount
  }
}`

export const requestVendorPayout = `mutation RequestVendorPayout($restaurant:ID!,$amount:Float!,$note:String){
  requestVendorPayout(restaurant:$restaurant,amount:$amount,note:$note){
    _id
    restaurantId
    amount
    status
    requestNote
    createdAt
  }
}`

export const processVendorPayout = `mutation ProcessVendorPayout($id:ID!,$status:String!,$adminNote:String){
  processVendorPayout(id:$id,status:$status,adminNote:$adminNote){
    _id
    amount
    status
    adminNote
    updatedAt
  }
}`

export const updateWithdrawReqStatus = `mutation UpdateWithdrawRequest($id:ID!, $status:String!){
  updateWithdrawReqStatus(id:$id,status:$status){
    _id
    status
    amount
    rider{
      _id
      currentWalletAmount
    }
  }
}`


export const deleteUser = `mutation DeleteUser($id:ID!){
  deleteUser(id:$id){
    _id
    isActive
  }
}`

export const restoreUser = `mutation RestoreUser($id:ID!){
  restoreUser(id:$id){
    _id
    isActive
  }
}`

export const updateOrderModes = `mutation UpdateOrderModes($restaurantId:ID!,$enableDelivery:Boolean!,$enablePickup:Boolean!,$enablePickupCOD:Boolean){
  updateOrderModes(restaurantId:$restaurantId,enableDelivery:$enableDelivery,enablePickup:$enablePickup,enablePickupCOD:$enablePickupCOD){
    _id
    enableDelivery
    enablePickup
    enablePickupCOD
  }
}`

export const forgotVendorPassword = `mutation ForgotVendorPassword($email:String!,$otp:String!){
  forgotVendorPassword(email:$email,otp:$otp){
    result
    message
  }
}`

export const verifyVendorOtp = `mutation VerifyVendorOtp($email:String!,$code:String!){
  verifyVendorOtp(email:$email,code:$code){
    result
    message
  }
}`

export const resetVendorPassword = `mutation ResetVendorPassword($email:String!,$password:String!,$code:String){
  resetVendorPassword(email:$email,password:$password,code:$code){
    result
    message
  }
}`

export const sendRestaurantTempPassword = `
  mutation SendRestaurantTempPassword($restaurantId: ID!) {
    sendRestaurantTempPassword(restaurantId: $restaurantId)
  }
`

export const createPromotion = `
  mutation CreatePromotion($input: PromotionInput!) {
    createPromotion(input: $input) {
      _id name status promotionType
    }
  }
`

export const updatePromotion = `
  mutation UpdatePromotion($id: ID!, $input: PromotionInput!) {
    updatePromotion(id: $id, input: $input) {
      _id name status promotionType
    }
  }
`

export const publishPromotion = `
  mutation PublishPromotion($id: ID!) {
    publishPromotion(id: $id) { _id name status }
  }
`

export const pausePromotion = `
  mutation PausePromotion($id: ID!) {
    pausePromotion(id: $id) { _id name status }
  }
`

export const archivePromotion = `
  mutation ArchivePromotion($id: ID!) {
    archivePromotion(id: $id) { _id name status }
  }
`

export const duplicatePromotion = `
  mutation DuplicatePromotion($id: ID!) {
    duplicatePromotion(id: $id) { _id name status }
  }
`

export const deletePromotion = `
  mutation DeletePromotion($id: ID!) {
    deletePromotion(id: $id)
  }
`

export const saveDeliveryZones = `
  mutation SaveDeliveryZones($restaurantId: ID!, $zones: [RestaurantDeliveryZoneInput!]!) {
    saveDeliveryZones(restaurantId: $restaurantId, zones: $zones) {
      _id
      name
      fee
      sortOrder
      polygon {
        coordinates
      }
    }
  }
`

export const saveVendorSelfDeliveryZones = `
  mutation SaveVendorSelfDeliveryZones($restaurantId: ID!, $zones: [RestaurantDeliveryZoneInput!]!) {
    saveVendorSelfDeliveryZones(restaurantId: $restaurantId, zones: $zones) {
      _id
      name
      fee
      sortOrder
      polygon {
        coordinates
      }
    }
  }
`

export const toggleSelfDelivery = `
  mutation ToggleSelfDelivery($restaurantId: ID!, $enabled: Boolean!) {
    toggleSelfDelivery(restaurantId: $restaurantId, enabled: $enabled)
  }
`

// When the restaurant's own drivers deliver: mode OFF | ALWAYS | DAILY | TODAY,
// fromMinute = local minutes after midnight it starts (null = now).
export const setSelfDeliverySchedule = `
  mutation SetSelfDeliverySchedule($restaurantId: ID!, $mode: String!, $fromMinute: Int) {
    setSelfDeliverySchedule(restaurantId: $restaurantId, mode: $mode, fromMinute: $fromMinute) {
      selfDelivery mode fromMinute startsAt until activeNow summary
    }
  }
`

export const saveDistanceBands = `
  mutation SaveDistanceBands($restaurantId: ID!, $bands: [DistanceBandInput!]!) {
    saveDistanceBands(restaurantId: $restaurantId, bands: $bands) {
      _id
      restaurantId
      maxMiles
      fee
      sortOrder
    }
  }
`

export const setDeliveryFeeMode = `
  mutation SetDeliveryFeeMode($restaurantId: ID!, $mode: String!) {
    setDeliveryFeeMode(restaurantId: $restaurantId, mode: $mode)
  }
`

export const savePlatformDistancePricing = `
  mutation SavePlatformDistancePricing($mode: String!, $bands: [PlatformDistanceBandInput!]!) {
    savePlatformDistancePricing(mode: $mode, bands: $bands) {
      mode
      bands {
        _id
        maxMiles
        fee
        sortOrder
      }
    }
  }
`

export const saveLoyaltyConfig = `
  mutation SaveLoyaltyConfig($input: LoyaltyConfigInput!) {
    saveLoyaltyConfig(input: $input) {
      pointsPerDollar
      minOrderForRedemption
      couponExpiryDays
      allowStackWithPromo
      annualTierReset
    }
  }
`

export const saveLoyaltyRedemptionTier = `
  mutation SaveLoyaltyRedemptionTier($input: LoyaltyRedemptionTierInput!) {
    saveLoyaltyRedemptionTier(input: $input) {
      _id
      pointsRequired
      couponValue
      isActive
      sortOrder
    }
  }
`

export const deleteLoyaltyRedemptionTier = `
  mutation DeleteLoyaltyRedemptionTier($id: ID!) {
    deleteLoyaltyRedemptionTier(id: $id)
  }
`

export const saveLoyaltyTierConfig = `
  mutation SaveLoyaltyTierConfig($input: LoyaltyTierConfigInput!) {
    saveLoyaltyTierConfig(input: $input) {
      _id
      tierName
      tierKey
      minLifetimePoints
      maxLifetimePoints
      earningMultiplier
    }
  }
`

export const saveLoyaltyCampaign = `
  mutation SaveLoyaltyCampaign($input: LoyaltyCampaignInput!) {
    saveLoyaltyCampaign(input: $input) {
      _id
      name
      multiplier
      startsAt
      endsAt
      isActive
    }
  }
`

export const deleteLoyaltyCampaign = `
  mutation DeleteLoyaltyCampaign($id: ID!) {
    deleteLoyaltyCampaign(id: $id)
  }
`

export const adminAdjustPoints = `
  mutation AdminAdjustPoints($userId: ID!, $points: Int!, $reason: String!) {
    adminAdjustPoints(userId: $userId, points: $points, reason: $reason) {
      balance
      lifetimePoints
      tier
    }
  }
`


export const adminCancelBlackCard = `
  mutation AdminCancelBlackCard($userId: ID!) {
    adminCancelBlackCard(userId: $userId) {
      _id
      status
      currentPeriodEnd
      cancelledAt
    }
  }
`

export const saveBlackCardProgram = `
  mutation SaveBlackCardProgram($input: BlackCardProgramInput!) {
    saveBlackCardProgram(input: $input) {
      enabled
      monthlyPrice
      deliveryDiscountCap
      bonusPointsPerOrder
      updatedAt
    }
  }
`

// ── Staff Management ──────────────────────────────────────────────────────────

export const staffLogin = `
  mutation StaffLogin($email: String!, $password: String!) {
    staffLogin(email: $email, password: $password) {
      userId
      token
      email
      firstName
      lastName
      role
      restaurantId
      restaurantName
    }
  }
`

export const sendStaffPhoneOtp = `
  mutation SendStaffPhoneOtp($phone: String!) {
    sendStaffPhoneOtp(phone: $phone) {
      result
      message
    }
  }
`

export const verifyStaffPhoneOtp = `
  mutation VerifyStaffPhoneOtp($phone: String!, $otp: String!) {
    verifyStaffPhoneOtp(phone: $phone, otp: $otp) {
      result
      message
    }
  }
`

export const createStaff = `
  mutation CreateStaff($staffInput: StaffInput!, $restaurantId: ID) {
    createStaff(staffInput: $staffInput, restaurantId: $restaurantId) {
      _id
      firstName
      lastName
      email
      phone
      address
      role
      isActive
      phoneVerified
      createdAt
    }
  }
`

export const editStaff = `
  mutation EditStaff($staffInput: EditStaffInput!, $restaurantId: ID) {
    editStaff(staffInput: $staffInput, restaurantId: $restaurantId) {
      _id
      firstName
      lastName
      email
      phone
      address
      role
      isActive
      phoneVerified
      createdAt
    }
  }
`

export const deleteStaff = `
  mutation DeleteStaff($id: ID!, $restaurantId: ID) {
    deleteStaff(id: $id, restaurantId: $restaurantId) {
      _id
    }
  }
`

export const forgotStaffPassword = `
  mutation ForgotStaffPassword($email: String!) {
    forgotStaffPassword(email: $email) {
      result
      message
    }
  }
`

export const reactivateStaff = `
  mutation ReactivateStaff($id: ID!, $restaurantId: ID) {
    reactivateStaff(id: $id, restaurantId: $restaurantId) {
      _id
      firstName
      lastName
      email
      role
      isActive
    }
  }
`

export const promoteDriverToRushMyFood = `
  mutation PromoteDriverToRushMyFood($riderId: ID!, $zoneId: ID!, $restaurantId: ID) {
    promoteDriverToRushMyFood(riderId: $riderId, zoneId: $zoneId, restaurantId: $restaurantId) {
      _id
      name
      driverType
      zone {
        _id
        title
      }
    }
  }
`

export const setStaffPassword = `
  mutation SetStaffPassword($token: String!, $password: String!) {
    setStaffPassword(token: $token, password: $password) {
      result
      message
    }
  }
`

export const resendStaffInvite = `
  mutation ResendStaffInvite($id: ID!, $restaurantId: ID) {
    resendStaffInvite(id: $id, restaurantId: $restaurantId) {
      result
      message
    }
  }
`

export const setOnDutyStaff = `
  mutation SetOnDutyStaff($staffIds: [ID!]!, $restaurantId: ID) {
    setOnDutyStaff(staffIds: $staffIds, restaurantId: $restaurantId) {
      onDutyStaff {
        _id
        firstName
        lastName
        role
      }
    }
  }
`

export const assignOrderToStaff = `
  mutation AssignOrderToStaff($orderId: ID!, $staffId: ID) {
    assignOrderToStaff(orderId: $orderId, staffId: $staffId) {
      result
      message
    }
  }
`

export const recordStaffPayout = `
  mutation RecordStaffPayout($staffId: ID!, $amount: Float!, $method: String!, $note: String, $restaurantId: ID) {
    recordStaffPayout(staffId: $staffId, amount: $amount, method: $method, note: $note, restaurantId: $restaurantId) {
      _id
      staffId
      amount
      method
      note
      paidAt
      createdAt
    }
  }
`

export const updateAutoAccept = `
  mutation UpdateAutoAccept($restaurantId: ID, $autoAccept: Boolean!, $prepTime: Int!) {
    updateAutoAccept(restaurantId: $restaurantId, autoAccept: $autoAccept, prepTime: $prepTime) {
      _id
      autoAccept
      defaultPrepTime
    }
  }
`

export const setRestaurantDispatchMode = `
  mutation SetRestaurantDispatchMode($restaurantId: ID!, $mode: String!) {
    setRestaurantDispatchMode(restaurantId: $restaurantId, mode: $mode)
  }
`

export const setRestaurantFallbackPolicy = `
  mutation SetRestaurantFallbackPolicy($restaurantId: ID!, $policy: String!) {
    setRestaurantFallbackPolicy(restaurantId: $restaurantId, policy: $policy)
  }
`

const PAYOUT_FIELDS = `
  opt1Enabled opt1HourlyRate
  opt2Enabled opt2HourlyRate opt2PerOrderBonus
  opt3Enabled opt3FlatFeePerOrder
  opt4Enabled opt4BaseFee opt4PerMileRate
  opt5Enabled opt5PercentOfDeliveryFee
  opt6Enabled opt6MinimumPerDelivery
  opt8Enabled opt8BonusPerExtraOrder
`

export const getPlatformPayoutConfig = `
  query PlatformPayoutConfig {
    platformPayoutConfig { ${PAYOUT_FIELDS} }
  }
`

export const getRestaurantPayoutConfig = `
  query RestaurantPayoutConfig($restaurantId: ID!) {
    restaurantPayoutConfig(restaurantId: $restaurantId) { ${PAYOUT_FIELDS} }
  }
`

export const getRiderPayoutOverride = `
  query RiderPayoutOverride($riderId: ID!) {
    riderPayoutOverride(riderId: $riderId) { ${PAYOUT_FIELDS} }
  }
`

export const savePlatformPayoutConfig = `
  mutation SavePlatformPayoutConfig($input: PayoutConfigInput!) {
    savePlatformPayoutConfig(input: $input) { ${PAYOUT_FIELDS} }
  }
`

export const saveRestaurantPayoutConfig = `
  mutation SaveRestaurantPayoutConfig($restaurantId: ID!, $input: PayoutConfigInput!) {
    saveRestaurantPayoutConfig(restaurantId: $restaurantId, input: $input) { ${PAYOUT_FIELDS} }
  }
`

export const saveRiderPayoutOverride = `
  mutation SaveRiderPayoutOverride($riderId: ID!, $input: PayoutConfigInput) {
    saveRiderPayoutOverride(riderId: $riderId, input: $input) { ${PAYOUT_FIELDS} }
  }
`

export const clearRiderPayoutOverride = `
  mutation ClearRiderPayoutOverride($riderId: ID!) {
    clearRiderPayoutOverride(riderId: $riderId)
  }
`

export const getRestaurantOwedRiders = `
  query RestaurantOwedRiders($restaurantId: ID!) {
    restaurantOwedRiders(restaurantId: $restaurantId) {
      riderId riderName riderPhone owedAmount
    }
  }
`

export const getRestaurantPayoutRequests = `
  query RestaurantPayoutRequests($restaurantId: ID!, $limit: Int) {
    restaurantPayoutRequests(restaurantId: $restaurantId, limit: $limit) {
      _id riderId riderName restaurantId restaurantName amount status notes paidAt createdAt
    }
  }
`

export const markRestaurantPayoutPaid = `
  mutation MarkRestaurantPayoutPaid($payoutRequestId: ID!, $notes: String) {
    markRestaurantPayoutPaid(payoutRequestId: $payoutRequestId, notes: $notes) {
      _id status notes paidAt
    }
  }
`

export const cancelRestaurantPayout = `
  mutation CancelRestaurantPayout($payoutRequestId: ID!) {
    cancelRestaurantPayout(payoutRequestId: $payoutRequestId) {
      _id status
    }
  }
`

export const getStripeConnectStatuses = `
  query StripeConnectStatuses {
    stripeConnectStatuses { accountId payoutsEnabled }
  }
`

export const recordQorRestaurantDebt = `mutation RecordQorRestaurantDebt($restaurantId:ID!,$amount:Float!,$orderId:ID,$note:String){
  recordQorRestaurantDebt(restaurantId:$restaurantId,amount:$amount,orderId:$orderId,note:$note){
    _id
    restaurantId
    kind
    amount
  }
}`

export const settleQorRestaurantDebt = `mutation SettleQorRestaurantDebt($restaurantId:ID!,$amount:Float!,$kind:String!,$note:String){
  settleQorRestaurantDebt(restaurantId:$restaurantId,amount:$amount,kind:$kind,note:$note){
    count
    outstanding{
      restaurantId
      restaurantName
      outstanding
    }
  }
}`

// ── Food truck stops ────────────────────────────────────────────────────────
const STOP_FIELDS = `
  _id
  truckId
  label
  address
  imageUrl
  latitude
  longitude
  isCheckedIn
  recurrence
  stopDate
  dayOfWeek
  weekOfMonth
  scheduleLabel
  hasOwnMenu
  stockMode
  recurrenceStartDate
  recurrenceEndDate
  exceptionDates
  startMinute
  endMinute
  windowLabel
  status
  isAdHoc
  notes
  isPaused
  pausedUntil
  pauseReason
`

export const createRestaurantStop = `mutation CreateRestaurantStop($restaurantId:ID,$stop:StopInput!){
  createRestaurantStop(restaurantId:$restaurantId,stop:$stop){ ${STOP_FIELDS} }
}`

export const updateRestaurantStop = `mutation UpdateRestaurantStop($id:ID!,$stop:StopInput!){
  updateRestaurantStop(id:$id,stop:$stop){ ${STOP_FIELDS} }
}`

export const deleteRestaurantStop = `mutation DeleteRestaurantStop($id:ID!){
  deleteRestaurantStop(id:$id)
}`

export const checkOutOfStop = `mutation CheckOutOfStop($restaurantId:ID,$stopId:ID){
  checkOutOfStop(restaurantId:$restaurantId,stopId:$stopId){ ${STOP_FIELDS} }
}`

export const pauseRestaurantStop = `mutation PauseRestaurantStop($id:ID!,$until:String,$reason:String){
  pauseRestaurantStop(id:$id,until:$until,reason:$reason){ ${STOP_FIELDS} }
}`

export const resumeRestaurantStop = `mutation ResumeRestaurantStop($id:ID!){
  resumeRestaurantStop(id:$id){ ${STOP_FIELDS} }
}`

export const skipStopDate = `mutation SkipStopDate($id:ID!,$date:String!){
  skipStopDate(id:$id,date:$date){ ${STOP_FIELDS} }
}`

export const unskipStopDate = `mutation UnskipStopDate($id:ID!,$date:String!){
  unskipStopDate(id:$id,date:$date){ ${STOP_FIELDS} }
}`

export const duplicateRestaurantStop = `mutation DuplicateRestaurantStop($id:ID!,$stopDate:String!){
  duplicateRestaurantStop(id:$id,stopDate:$stopDate){ ${STOP_FIELDS} }
}`

// ── Trucks under one food-truck restaurant (migration 145) ──────────────────
const TRUCK_FIELDS = `
  _id
  restaurantId
  name
  displayOrder
  isActive
`

export const createRestaurantTruck = `mutation CreateRestaurantTruck($restaurantId:ID,$name:String!){
  createRestaurantTruck(restaurantId:$restaurantId,name:$name){ ${TRUCK_FIELDS} }
}`

export const updateRestaurantTruck = `mutation UpdateRestaurantTruck($id:ID!,$name:String,$displayOrder:Int){
  updateRestaurantTruck(id:$id,name:$name,displayOrder:$displayOrder){ ${TRUCK_FIELDS} }
}`

// Refused while the truck still has stops on the schedule, or when it is the
// last truck; the error message says which.
export const deleteRestaurantTruck = `mutation DeleteRestaurantTruck($id:ID!){
  deleteRestaurantTruck(id:$id)
}`

// useFullMenu: items only carry on-hand counts. Otherwise items with
// included !== false are what the stop sells; price / variantPrices are the
// stop-only price (left out = regular price). The rows sent replace all counts.
export const saveStopMenu = `mutation SaveStopMenu($stopId:ID!,$useFullMenu:Boolean!,$stockMode:String,$items:[StopMenuItemInput!]){
  saveStopMenu(stopId:$stopId,useFullMenu:$useFullMenu,stockMode:$stockMode,items:$items){
    stopId
    useFullMenu
    stockMode
    items{
      itemId
      name
      categoryName
      imageUrl
      pricingMode
      regularPrice
      regularVariantPrices
      included
      stopPrice
      stopVariantPrices
      stockQuantity
      stockLeft
    }
  }
}`

// Super admin only: take a reported review down (views/Rating.jsx).
export const deleteReview = `mutation DeleteReview($id:ID!){
  deleteReview(id:$id)
}`
